import variance from "./variance";

export default function(array, f) {
  var v = variance(array, f);
  return v ? Math.sqrt(v) : v;
}



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-array/src/deviation.js
// module id = /gd/
// module chunks = 0